import React from "react";
import { Helmet } from "react-helmet";
const GamedevHelmet = ({ title }) => {
  return (
    <Helmet>
      <title>
        Top Game Development Company in USA
      </title>
      <meta
        name="description"
        content="Leading game development services in USA. Reach out today to build custom 2D, 3D, and Web3 games that engage players and drive growth."
      />
    </Helmet>
  );
};

export default GamedevHelmet;
